module.exports = __webpack_public_path__ + "img/result-element.977983b6.svg";